import { render, staticRenderFns } from "./AiChatbotWindow.vue?vue&type=template&id=04100430&scoped=true"
import script from "./AiChatbotWindow.vue?vue&type=script&lang=ts"
export * from "./AiChatbotWindow.vue?vue&type=script&lang=ts"
import style0 from "./AiChatbotWindow.vue?vue&type=style&index=0&id=04100430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04100430",
  null
  
)

export default component.exports